import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
    TierRasse,
    TierRasseOutput,
    TierRasseSonstige, Tierrasse2,
} from '../../../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/tier-rasse';
import { API_BASE_URL_SERVICE } from '../../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Tierart } from '../../../../administration/tierarten/tierart';

@Component({
    selector: 'kiene-sonstige-rassen-dialog',
    templateUrl: './sonstige-rassen-dialog.component.html',
    styleUrls: ['./sonstige-rassen-dialog.component.scss'],
})
export class SonstigeRassenDialogComponent implements OnInit {
    tierarten: Tierart[] = [];
    rasse_name_ctrl = new UntypedFormControl('', Validators.required);
    tierartCtrl: UntypedFormControl = new UntypedFormControl(null, Validators.required);

    constructor(
        public dialogRef: MatDialogRef<SonstigeRassenDialogComponent>,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly messageService: MessageService,
        private readonly api: KieneBackendApiService,
        @Inject(MAT_DIALOG_DATA) public data: Tierrasse2,
    ) {}

    ngOnInit(): void {
        this.loadTierarten();
        if (this.data) {
            this.rasse_name_ctrl.setValue(this.data.name);
            this.tierartCtrl.setValue(this.data.tierart_id);
        }
    }

    private loadTierarten() {
        this.api.get(this.apiBaseUrl + 'tierart/read.php').subscribe({
            next: response => {
                this.tierarten = response.records || [];

                // For create flow preselect first Tierart so save is possible.
                if (!this.tierartCtrl.value && this.tierarten.length > 0) {
                    this.tierartCtrl.setValue(this.tierarten[0]);
                }
            },
        });
    }

    cancel() {
        this.dialogRef.close(null);
    }

    public save() {
        const tierrasse = new TierRasseSonstige();
        const selectedTierart = this.tierartCtrl.value;
        tierrasse.tierrasse_id = this.data?.tierrasse_id;
        tierrasse.tierart_id = selectedTierart?.tierart_id ?? selectedTierart ?? this.data?.tierart_id;
        tierrasse.rasse = this.rasse_name_ctrl.value;
        tierrasse.name = this.rasse_name_ctrl.value;

        this.api.post(this.apiBaseUrl + 'tierrasse/update.php', tierrasse).subscribe({
            next: (savedTierart: TierRasse) => {
                const output = new TierRasseOutput();
                output.rasse = savedTierart;
                output.confirm = true;
                this.dialogRef.close(savedTierart);
            },
            error: error => {
                this.messageService.errorMessage(
                    'Fehler! Die Tierrasse ' + tierrasse.name + ' konnte nicht gespeichert werden!',
                    error,
                );
            },
        });
    }

    public disabled(): boolean {
        return this.rasse_name_ctrl.invalid || this.tierartCtrl.invalid;
    }
}
